import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlayerfmComponent } from './simple-icons-playerfm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlayerfmComponent ],
    exports:      [ SimpleIconsPlayerfmComponent ],
    bootstrap:    []
})
export class SimpleIconsPlayerfmModule {}
